import { BusinessUnit } from '@shared/types/business-unit/BusinessUnit';
import { BusinessUnit as EntityBusinessUnit } from '@/types/entity/business-unit';
import { mapAddress } from './map-address';
import { mapStore } from './map-store';

export const mapBusinessUnit = (data: BusinessUnit): EntityBusinessUnit => {

  const {
    businessUnitId,
    key,
    name,
    legal_entity,
    contactEmail,
    addresses,
    stores,
    parent_account_number,
    branch_account_number,
    company_chain,
    feature_toggling
  } = data;
  return {
    id: businessUnitId as string,
    name: name ?? '',
    key: key ?? '',
    legal_entity: legal_entity ?? data?.LegalEntity ?? '',
    parent_account_number: parent_account_number ?? '',
    branch_account_number: branch_account_number ?? '',
    email: contactEmail ?? '',
    addresses: (addresses ?? []).map(mapAddress),
    stores: (stores ?? []).map(mapStore),
    company_chain,
    feature_toggling: data.feature_toggling,

  };
};
